import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { UserPreference } from '@rd/types';
import { UserPreferenceUpdateParams } from '@rd/types/user-preference-update.params';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPreferenceApiService {
  constructor(private nydusNetworkApiDataService: NydusNetworkApiDataService) {}

  updateUserPreference(userPreference: UserPreference): Observable<void> {
    const userPreferenceUpdateParams: UserPreferenceUpdateParams = {
      // @ts-ignore
      locale_code: userPreference.locale,
      // @ts-ignore
      currency_code: userPreference.currency,
      // @ts-ignore
      loyalty_currency_id: userPreference.loyaltyCurrency,
      // @ts-ignore
      points_account_id: userPreference.pointsAccountId,
    };

    return this.nydusNetworkApiDataService.put<void>(
      'user_preferences',
      userPreferenceUpdateParams,
    );
  }
}
